import type { ApiResponse } from "@/scripts/Common/api";
import { defaultFetch } from "@/scripts/Common/api";
import { httpMethod } from "@/scripts/Common/api/enums";
import type { AddOrUpdatePointOfSaleModel, FetchPointOfSalesParam, PointOfSale } from "./types";
import { getToken } from "@/scripts/Common";

const fetchCustomerPointOfSales = async (args: FetchPointOfSalesParam, abortSignal? : AbortSignal): Promise<ApiResponse<PointOfSale[]>> => {
  const { customerId, ...queryParams } = args;
  return await defaultFetch({
    apiName: 'pointOfSales',
    bearer: getToken(),
    options: {
      query: {
        ...queryParams,
        pageNumber: typeof queryParams?.pageNumber === 'number' ? Math.max(0, queryParams.pageNumber - 1) : undefined, // reduce by 1 to make it 0 based
      },
      routeParams: {
        customerId: customerId.toString()
      },
      abortSignal
    }
  });
}

const getPointOfSaleById = async (customerId: number, pointOfSaleId: number): Promise<ApiResponse<PointOfSale>> => {
  return await defaultFetch({
    apiName: 'pointOfSale',
    bearer: getToken(),
    options: {
      routeParams: {
        customerId: customerId.toString(),
        pointOfSaleId: pointOfSaleId.toString()
      }
    }
  });
}

const createPointOfSale = async (customerId: number, model: AddOrUpdatePointOfSaleModel): Promise<ApiResponse<PointOfSale>> => {
  return await defaultFetch({
    apiName: 'pointOfSales',
    bearer: getToken(),
    body: JSON.stringify(model),
    options: {
      method: httpMethod.POST,
      routeParams: {
        customerId: customerId.toString()
      }
    }
  });
}

const updatePointOfSale = async (customerId: number, pointOfSaleId: number, model: AddOrUpdatePointOfSaleModel): Promise<ApiResponse<PointOfSale>> => {
  return await defaultFetch({
    apiName: 'pointOfSale',
    bearer: getToken(),
    body: JSON.stringify(model),
    options: {
      method: httpMethod.PUT,
      routeParams: {
        customerId: customerId.toString(),
        pointOfSaleId: pointOfSaleId.toString()
      }
    }
  });
}

const deletePointOfSale = async (customerId: number, pointOfSaleId: number): Promise<ApiResponse<void>> => {
  return await defaultFetch({
    apiName: 'pointOfSale',
    bearer: getToken(),
    options: {
      method: httpMethod.DELETE,
      routeParams: {
        customerId: customerId.toString(),
        pointOfSaleId: pointOfSaleId.toString()
      }
    }
  });
}

export {
  fetchCustomerPointOfSales,
  getPointOfSaleById,
  createPointOfSale,
  updatePointOfSale,
  deletePointOfSale
}
